document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          document
            .querySelectorAll('.statistics svg animate')
            .forEach((animate) => animate.beginElement());
          observer.unobserve(entry.target); // Unobserve after animation starts
        }
      });
    },
    { rootMargin: '0px', threshold: 0.1 }
  );
  observer.observe(document.querySelector('.statistics'));
});
